import { useEffect } from 'react';
import { identityStore } from '../store/store';
import { meRequest } from '../api/me';

export function useInitializationBehaviour() {
  useEffect(() => {
    (async () => {
      const user = await meRequest().catch(() => undefined);
      identityStore.getState().update({ user, initialized: true });
    })();
  }, []);
}
